import { Menu, MenuItem } from "@mui/material";
import { MuiBox, MuiTypography } from "components/atoms";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import Swal from "sweetalert2";
import { openAdminModal } from "store/slices/common/adminModal.slice";
import { Button } from "components/ui";
import { EllipsisVertical, Pencil, Trash } from "lucide-react";
import DeleteIconSVGModel from "assets/images/deleteIconSVGModel.svg";
import { DeleteHobbyAction } from "store/middlewares/dataManagement/hobby";
import ModalEditHobby from "components/molecules/DataManagement/ModalEditHobby";
import checkAccess from "utils/checkAccess";

const Hobby = ({ row, onActionComplete }) => {
  // Add onActionComplete prop
  const dispatch = useDispatch();

  const handleEdit = () => {
    dispatch(
      openAdminModal({
        title: "Edit Hobby",
        content: <ModalEditHobby row={row} />,
      }),
    );
    // After opening edit modal, refresh data and clear search
    if (onActionComplete) {
      onActionComplete();
    }
  };

  const handleDelete = () => {
    Swal.fire({
      title: `Are you sure you want to delete this hobby?`,
      imageUrl: DeleteIconSVGModel,
      imageWidth: 100,
      imageHeight: 100,
      showCancelButton: true,
      confirmButtonText: "Confirm",
      customClass: {
        popup: "custom-swal-popup",
        title: "Swal-title-class",
        confirmButton: "custom-swal-confirm",
        cancelButton: "custom-swal-cancel",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(
          DeleteHobbyAction({
            id: row.id,
            onSuccess: () => {
              // After successful deletion, refresh data and clear search
              if (onActionComplete) {
                // Use setTimeout to ensure this runs after the delete action completes
                setTimeout(() => {
                  onActionComplete();
                }, 100);
              }
              Swal.fire({
                title: "Deleted!",
                text: "Hobby has been deleted successfully.",
                icon: "success",
                timer: 2000,
                showConfirmButton: false,
              });
            },
          }),
        );
      }
    });
  };

  //--------------------------------------------------- Action Menu Array --------------------------------------
  const ActionMenuArray = [
    checkAccess("update_hobby") && {
      label: "Edit",
      icon: <Pencil size={16} color="#475569" />,
      onClick: handleEdit, // Use the handleEdit function
    },
    row.total_count <= 0 &&
      checkAccess("delete_hobby") && {
        label: "Delete",
        icon: <Trash size={16} color="#475569" />,
        onClick: handleDelete, // Use the handleDelete function
      },
  ].filter(Boolean);

  // For action menu
  const [actionMenu, setActionMenu] = useState(null);
  const handleActionMenuOpen = (event) => {
    setActionMenu(event.currentTarget);
  };
  const handleActionMenuClose = () => {
    setActionMenu(null);
  };

  return (
    <MuiBox className="flex h-full items-center justify-center gap-3">
      <Button
        className="size-7"
        mode="icon"
        variant="ghost"
        onClick={handleActionMenuOpen}
      >
        <EllipsisVertical />
      </Button>
      <Menu
        anchorEl={actionMenu}
        open={Boolean(actionMenu)}
        onClose={() => handleActionMenuClose(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        sx={{
          " & .MuiMenu-paper": {
            mt: "10px",
            background: "#fff",
            boxShadow:
              "0 4px 6px -1px #e2e8f0, 0 2px 4px -2px #e2e8f0 !important",
          },
        }}
      >
        {ActionMenuArray.map((option) => (
          <MenuItem
            key={option.label}
            onClick={() => {
              handleActionMenuClose();
              option.onClick();
            }}
          >
            <MuiBox sx={{ display: "flex", alignItems: "center", gap: "9px" }}>
              <MuiBox sx={{ width: "fit-content" }}>{option.icon}</MuiBox>
              <MuiTypography
                sx={{ fontWeight: "500", fontSize: "13px", color: "#475569" }}
              >
                {option.label}
              </MuiTypography>
            </MuiBox>
          </MenuItem>
        ))}
      </Menu>
    </MuiBox>
  );
};

export default Hobby;
